import {
  Building2,
  Utensils,
  DoorOpen,
  HandHeart,
  ChefHat,
  Bus,
} from "lucide-react";
import { FACILITIES } from "@/lib/siteData";

const ICONS = [Building2, Utensils, DoorOpen, HandHeart, ChefHat, Bus];

export default function Facilities() {
  return (
    <section
      id="facilities"
      className="py-24 md:py-32"
      data-testid="facilities-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-14 items-end">
          <div className="lg:col-span-7">
            <p className="eyebrow" data-testid="facilities-overline">Facilities</p>
            <h2
              className="mt-4 font-headings text-3xl md:text-5xl text-primary leading-tight"
              data-testid="facilities-heading"
            >
              Exceptional facilities for a seamless experience.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-body text-base md:text-lg text-foreground/75 leading-relaxed">
              To make sure your big day runs smoothly, we provide a host of essential amenities
              and infrastructure designed for convenience and comfort.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
          {FACILITIES.map((f, i) => {
            const Icon = ICONS[i] || Building2;
            return (
              <div
                key={f.title}
                className="bg-background p-8 md:p-10 flex flex-col gap-4 group hover:bg-accent/50 transition-colors"
                data-testid={`facility-${i}`}
              >
                <Icon
                  size={26}
                  strokeWidth={1.4}
                  className="text-secondary group-hover:text-primary transition-colors"
                />
                <h3 className="font-headings text-xl md:text-2xl text-foreground">
                  {f.title}
                </h3>
                <p className="font-body text-[15px] md:text-base text-foreground/75 leading-relaxed">
                  {f.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
